(function () {
  'use strict';
  /* HitchFire — "Customers also purchase" inside the cart slide-out drawer.
     Replaces the old post-add popup (assets/hf-xsell.js, now retired) and the
     drawer's previous automatic "You might also need" row.

     Same experience the popup had: order-mined pairs, tick-to-select rows, a
     10% saving on anything covered by the accessories coupon, and one button
     that adds everything picked. The drawer's own Secure Checkout button then
     carries the shopper straight to checkout with the coupon already applied
     (hf-pdp-atc.js keeps [data-cart-checkout] in sync after every cart write).

     Pairs mined from the trailing 300 real orders (2026-06-08 -> 2026-08-17).
     Loaded from snippets/hf-cart-drawer-js.liquid, gated on the theme setting
     "Show Customers also purchase in the cart drawer". */

  if (window.HFCartXsell) return;

  var ACC_HANDLE = 'hitchfire-accessories-1';
  var ACC_CACHE_KEY = 'hf_acc_ids';   // shared with hf-pdp-atc.js
  var SAVE_PCT = 0.10;
  var MAX_ROWS = 3;

  var PAIRS = {
    'f-20': [
      { h: 'forge-15-grill-cover',      why: 'Added to 79% of F-20 orders' },
      { h: 'cutting-board-side-table',  why: 'Added to 53% of F-20 orders' },
      { h: 'gas-growler',               why: 'Added to 32% of F-20 orders' }
    ],
    'hitchfire-grill': [
      { h: 'forge-15-grill-cover',      why: 'Added to 50% of Forge 15 orders' },
      { h: 'locking-hitch-pin',         why: 'Added to 30% of Forge 15 orders' },
      { h: '20-lb-propane-tank-adapter-hose', why: 'Run two burners off one tank' }
    ],
    'ledge-xl': [
      { h: 'hitchfire-stabilizing-kickstand-support', why: 'Added to 30% of Ledge XL orders' },
      { h: 'locking-hitch-pin',         why: 'Added to 20% of Ledge XL orders' },
      { h: 'cam-straps',                why: 'Added to 13% of Ledge XL orders' }
    ],
    'ledge-platform': [
      { h: 'hitchfire-stabilizing-kickstand-support', why: 'Keeps the platform steady when loaded' },
      { h: 'locking-hitch-pin',         why: 'Locks your rig to the receiver' },
      { h: 'cam-straps',                why: 'Strap down what you haul' }
    ],
    'hitch-kitchen': [
      { h: 'hitchfire-cover-for-field-box-hitch-kitchen', why: 'Added to every Hitch Kitchen order' },
      { h: 'gas-growler',               why: 'Added to 60% of Hitch Kitchen orders' },
      { h: 'hitchfire-stabilizing-kickstand-support', why: 'Added to 40% of Hitch Kitchen orders' }
    ],
    'camp-kitchen': [
      { h: 'gas-growler',               why: 'Refillable 5lb tank — no more swaps' },
      { h: 'hitchfire-stabilizing-kickstand-support', why: 'Steadies a loaded kitchen' },
      { h: 'cutting-board-side-table',  why: 'Adds prep space where you need it' }
    ],
    'cook-station-mobile-kitchen': [
      { h: 'hitchfire-stabilizing-kickstand-support', why: 'Added to 40% of Cook Station orders' },
      { h: 'locking-hitch-pin',         why: 'Added to 30% of Cook Station orders' },
      { h: '20-lb-propane-tank-adapter-hose', why: 'Added to 20% of Cook Station orders' }
    ]
  };
  var FALLBACK = [
    { h: 'gas-growler',               why: 'Our most-added accessory' },
    { h: 'hitchfire-stabilizing-kickstand-support', why: 'Popular with every hitch-mounted rig' },
    { h: 'forge-15-grill-cover',      why: 'Keeps your gear protected' }
  ];

  var drawer = document.querySelector('[data-cart-drawer]');
  if (!drawer) return;
  var wrap = drawer.querySelector('[data-cart-recs]');
  var list = drawer.querySelector('[data-cart-recs-list]');
  var addBtn = drawer.querySelector('[data-xsell-add]');
  if (!wrap || !list) return;

  var offers = [], picked = {}, busy = false, loading = false, lastKey = '';
  var prodCache = {};

  /* ---------- utils ---------- */
  function money(c) {
    return '$' + (Number(c) / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }
  function product(handle) {
    if (prodCache[handle]) return Promise.resolve(prodCache[handle]);
    return getJSON('/products/' + encodeURIComponent(handle) + '.js').then(function (p) {
      if (p) prodCache[handle] = p;
      return p;
    });
  }

  /* ---------- discount eligibility ----------
     Only products in the HitchFire Accessories collection are covered by the
     coupon, so only those may advertise a saving. Checked at runtime so the
     drawer can never promise a discount the checkout won't honour. */
  var accIds = null;
  function loadAccIds() {
    if (accIds) return Promise.resolve(accIds);
    try {
      var c = sessionStorage.getItem(ACC_CACHE_KEY);
      if (c) { accIds = JSON.parse(c); return Promise.resolve(accIds); }
    } catch (e) {}
    return getJSON('/collections/' + ACC_HANDLE + '/products.json?limit=250').then(function (d) {
      accIds = {};
      ((d && d.products) || []).forEach(function (p) { accIds[p.id] = 1; });
      try { sessionStorage.setItem(ACC_CACHE_KEY, JSON.stringify(accIds)); } catch (e) {}
      return accIds;
    });
  }

  /* ---------- analytics ---------- */
  function track(event, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      if (payload && payload.ecommerce) window.dataLayer.push({ ecommerce: null });
      var d = { event: event };
      for (var k in payload) { if (Object.prototype.hasOwnProperty.call(payload, k)) d[k] = payload[k]; }
      window.dataLayer.push(d);
    } catch (e) {}
  }
  function gaItem(o, i) {
    return {
      item_id: String(o.id),
      item_name: o.title,
      price: Number(((o.price - o.save) / 100).toFixed(2)),
      discount: Number((o.save / 100).toFixed(2)),
      item_list_id: 'hf_cart_xsell',
      item_list_name: 'Cart drawer — customers also purchase',
      index: i,
      quantity: 1
    };
  }
  function gaItems(l) { return l.map(function (o, i) { return gaItem(o, i); }); }

  /* ---------- pick what to offer ----------
     Walk the cart in order, collect the mined partners for each item, drop
     anything already in the cart, and cap the list. Products with no mined
     pair fall back to Shopify's own recommendations, then to site favourites,
     so the row is never empty for a non-anchor product. */
  function candidates(cart) {
    var inCart = {}, out = [], seen = {};
    (cart.items || []).forEach(function (it) { if (it.handle) inCart[it.handle] = 1; });
    (cart.items || []).forEach(function (it) {
      (PAIRS[it.handle] || []).forEach(function (r) {
        if (inCart[r.h] || seen[r.h]) return;
        seen[r.h] = 1; out.push(r);
      });
    });
    if (out.length) return Promise.resolve(out.slice(0, MAX_ROWS));

    var seed = (cart.items || [])[0];
    var viaShopify = seed
      ? getJSON('/recommendations/products.json?product_id=' + seed.product_id + '&limit=10&intent=related')
      : Promise.resolve(null);
    return viaShopify.then(function (d) {
      ((d && d.products) || []).forEach(function (p) {
        if (inCart[p.handle] || seen[p.handle]) return;
        seen[p.handle] = 1; out.push({ h: p.handle, why: 'Frequently bought with your gear' });
      });
      if (!out.length) {
        FALLBACK.forEach(function (r) { if (!inCart[r.h] && !seen[r.h]) { seen[r.h] = 1; out.push(r); } });
      }
      return out.slice(0, MAX_ROWS);
    });
  }

  function build(cart) {
    return Promise.all([candidates(cart), loadAccIds()]).then(function (res) {
      var recs = res[0] || [], ids = res[1] || {};
      return Promise.all(recs.map(function (r) { return product(r.h); })).then(function (prods) {
        var out = [];
        prods.forEach(function (p, i) {
          if (!p) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          var eligible = !!ids[p.id];
          out.push({
            id: v.id,
            handle: p.handle,
            url: p.url || ('/products/' + p.handle),
            title: p.title,
            why: recs[i].why,
            img: (p.featured_image || (p.images && p.images[0]) || ''),
            price: v.price,
            save: eligible ? Math.round(v.price * SAVE_PCT) : 0
          });
        });
        return out;
      });
    });
  }

  /* ---------- render ---------- */
  var TICK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"></polyline></svg>';

  function refreshBtn() {
    if (!addBtn) return;
    var keys = Object.keys(picked);
    if (!keys.length) { addBtn.hidden = true; return; }
    var sum = 0;
    keys.forEach(function (k) { var o = offers[k]; sum += (o.price - o.save); });
    addBtn.hidden = false;
    addBtn.disabled = false;
    addBtn.textContent = 'Add ' + keys.length + (keys.length > 1 ? ' items · ' : ' item · ') + money(sum);
  }

  function toggle(row) {
    var i = row.getAttribute('data-i');
    var on;
    if (picked[i]) { delete picked[i]; row.classList.remove('is-on'); row.setAttribute('aria-checked', 'false'); on = false; }
    else { picked[i] = 1; row.classList.add('is-on'); row.setAttribute('aria-checked', 'true'); on = true; }
    track(on ? 'hf_cart_xsell_select' : 'hf_cart_xsell_deselect', {
      ecommerce: { item_list_id: 'hf_cart_xsell', items: [gaItem(offers[i], Number(i))] }
    });
    refreshBtn();
  }

  function render() {
    picked = {};
    if (!offers.length) { wrap.hidden = true; if (addBtn) addBtn.hidden = true; return; }
    var anySave = offers.some(function (o) { return o.save > 0; });
    list.innerHTML = offers.map(function (o, i) {
      var now = o.price - o.save;
      return '<div class="cart-xs" data-i="' + i + '" role="checkbox" aria-checked="false" tabindex="0">' +
        '<span class="cart-xs__check">' + TICK + '</span>' +
        '<a class="cart-xs__thumb" href="' + esc(o.url) + '" tabindex="-1" aria-hidden="true"' +
          (o.img ? ' style="background-image:url(\'' + esc(o.img) + '\')"' : '') + '></a>' +
        '<span class="cart-xs__meta">' +
          '<span class="cart-xs__name">' + esc(o.title) + '</span>' +
          '<span class="cart-xs__why">' + esc(o.why) + '</span>' +
        '</span>' +
        '<span class="cart-xs__price">' +
          (o.save > 0 ? '<span class="cart-xs__was">' + money(o.price) + '</span>' : '') +
          '<span class="cart-xs__now">' + money(now) + '</span>' +
          (o.save > 0 ? '<span class="cart-xs__save">Save 10%</span>' : '') +
        '</span></div>';
    }).join('');
    wrap.hidden = false;
    wrap.classList.toggle('has-save', anySave);
    if (addBtn) { addBtn.hidden = true; addBtn.disabled = false; }

    list.querySelectorAll('.cart-xs').forEach(function (row) {
      row.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('a')) return;
        toggle(row);
      });
      row.addEventListener('keydown', function (e) {
        if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); toggle(row); }
      });
    });

    track('hf_cart_xsell_view', {
      hf_offer_count: offers.length,
      ecommerce: { item_list_id: 'hf_cart_xsell', item_list_name: 'Cart drawer — customers also purchase', items: gaItems(offers) }
    });
  }

  /* ---------- add ---------- */
  function reopenDrawer() {
    // Re-run the theme's own open path so lines, subtotal and the cart count
    // all re-render (same trick the old drawer recommendations used).
    var opener = document.querySelector('[data-cart-open]');
    if (opener) opener.click();
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (busy) return;
      var chosen = Object.keys(picked).map(function (k) { return offers[k]; });
      if (!chosen.length) return;
      busy = true;
      addBtn.disabled = true;
      addBtn.textContent = 'Adding…';
      var value = chosen.reduce(function (t, o) { return t + (o.price - o.save); }, 0);
      track('hf_cart_xsell_add_to_cart', {
        hf_added_count: chosen.length,
        hf_added_value: Number((value / 100).toFixed(2)),
        ecommerce: { currency: 'USD', value: Number((value / 100).toFixed(2)), items: gaItems(chosen) }
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: chosen.map(function (o) { return { id: o.id, quantity: 1 }; }) })
      }).then(function () {
        busy = false; lastKey = '';
        reopenDrawer();
        sync(true);
      }).catch(function () {
        busy = false;
        refreshBtn();
      });
    });
  }

  /* ---------- sync ---------- */
  function sync(force) {
    if (loading) return;
    loading = true;
    getJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.item_count) {
        offers = []; wrap.hidden = true; if (addBtn) addBtn.hidden = true;
        lastKey = ''; loading = false; return;
      }
      var key = (cart.items || []).map(function (i) { return i.handle; }).join('|');
      if (!force && key === lastKey && offers.length) { loading = false; return; }
      lastKey = key;
      build(cart).then(function (list2) {
        offers = list2 || [];
        render();
        loading = false;
      }).catch(function () { loading = false; });
    }).catch(function () { loading = false; });
  }

  // Refresh whenever the drawer transitions closed -> open (covers every open path).
  var wasOpen = drawer.classList.contains('is-open');
  new MutationObserver(function () {
    var isOpen = drawer.classList.contains('is-open');
    if (isOpen && !wasOpen) sync(false);
    wasOpen = isOpen;
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  // Refresh when the cart itself changes (line removed, quantity changed).
  var sub = drawer.querySelector('[data-cart-subtotal]');
  if (sub) {
    var t = null;
    new MutationObserver(function () {
      if (t) return;
      t = setTimeout(function () { t = null; if (drawer.classList.contains('is-open')) sync(false); }, 250);
    }).observe(sub, { childList: true, characterData: true, subtree: true });
  }

  if (drawer.classList.contains('is-open')) sync(false);

  window.HFCartXsell = { sync: sync };
})();
